export default "__VITE_ASSET__HKGAf4_9__"